import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'wysiwyg',
})
export class WysiwygPipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) {}
  public transform(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value);
  }
}
